export default __webpack_public_path__ + "static/media/50.5f8601c5.png";